import React from 'react';
import { useSearchParams, Navigate } from 'react-router-dom';
import ResetPasswordForm from '@/components/Auth/ResetPasswordForm';

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token');

  if (!token) {
    return <Navigate to="/authentication?mode=forgot" replace />;
  }

  return (
    <div className="min-h-screen bg-cream-paper flex items-center justify-center p-4 sm:p-6 text-gray-900">
      <div className="w-full max-w-md">
        <ResetPasswordForm token={token} />
      </div>
    </div>
  );
}
